export default {
  matches (state) {
    return {
      ...state,
      storeName: 'matches'
    }
  }
}
